import { useNavigate } from "react-router-dom";
import error404Icon from "../../assests/overlay/error-404.svg";

const ErrorPage = (props) => {
  const navigate = useNavigate();
  return (
    <div
      style={
        props.mobileScreen
          ? {
              alignItems: "center",
              justifyContent: "center",
              position: "unset",
              width: "100%",
              top: "0",
              bottom: "0",
              left: "0",
              right: "0",
              height: "100%",
              background: "#fff",
            }
          : {}
      }
      className="error-404-page"
    >
      <div
        style={
          props.mobileScreen
            ? { alignItems: "center", justifyContent: "center", width: "100%" }
            : {}
        }
        className="error-404-page-container"
      >
        <img src={error404Icon} alt="Error Icon" />
        <p className="error-404-page-title">Oops....</p>

        <div className="error-404-body-cont">
          <p className="error-404-body-title">Something went wrong</p>

          <p
            style={props.mobileScreen ? { maxWidth: "90%" } : {}}
            className="error-404-body-label"
          >
            This Page doesn't exist or was removed! We suggest you go back to
            home.
          </p>
        </div>
      </div>
      <button
        id="borrow-popup-next-button"
        onClick={async (e) => {
          navigate("/");
        }}
        style={
          props.mobileScreen ? { maxWidth: "200px", marginBottom: "200px" } : {}
        }
        className="startup-button-active"
      >
        <p className="add-funds-popup-a-f-button-text">Refresh</p>
      </button>
    </div>
  );
};

export default ErrorPage;
